export type RuntimeEnvKey =
    | 'REACT_APP_BASE_HOST'
    | 'REACT_APP_TELEGRAM_BOT_NAME'
    | 'REACT_APP_CONTENT_SITE_URL'
    | 'REACT_APP_INFO_EMAIL'
    | 'REACT_APP_SUPPORT_TELEGRAM'
    | 'REACT_APP_GITHUB_REPO_OWNER';

export const runtimeEnv = (key: RuntimeEnvKey): string =>
    (typeof window === 'undefined' ? undefined : window.__ENV__?.[key]) || process.env[key] || '';
